// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"26":"loggedOutHeaderFooter","143":"app","808":"appcenter","984":"ppvx"}[chunkId] + ".css";
};